import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { TemplateDataTable } from "./TemplateDataTable";
import { getSMSTemplateList, HOST_URL } from "../api/Api";
import Axios from "../../../axios/Axios";
import styles from "./SmsTemplateNew.module.css";

const SmsTemplate = () => {
    const login = JSON.parse(localStorage.getItem("login"));
    const userId = login?.user?.userId;
    const token = login?.token;

    const [enableEdit, setEnableEdit] = useState(0);

    /* PERMISSION */
    useEffect(() => {
        Axios.post(`${HOST_URL}/profile.php`, {
            user_id: userId,
            method: "retrieve",
            token,
        }).then((res) => {
            if (res.data?.success) {
                setEnableEdit(res.data.data[0]?.template_editable ?? 0);
            }
        });
    }, [userId, token]);

    /* DATA */
    const fetchSmsTemplates = useCallback(
        async ({ page, limit, search }) => {
            const payload = {
                user_id: userId,
                method: search ? "search" : "retrieve",
                keyword: search || null,
                id: null,
                token,
            };

            const response = search
                ? await Axios.post(`${HOST_URL}/sms_template.php`, payload)
                : await getSMSTemplateList(payload);

            if (!response?.data?.success) {
                return { data: [], total: 0 };
            }

            const rows = response.data.data;
            const start = (page - 1) * limit;

            return {
                data: rows.slice(start, start + limit),
                total: rows.length,
            };
        },
        [userId, token]
    );

    /* COLUMNS */
    const smsColumns = [
        {
            key: "template_name",
            label: "Name",
            width: "260px",
            headerClassName: styles.tableHeader,
            className: styles.cell,
            render: (row) => (
                <div>
                    <div className={styles.name}>{row.template_name}</div>
                    <div className={styles.updated}>
                        Created: {row.created}
                    </div>
                </div>
            ),
        },
        {
            key: "content",
            label: "SMS Content",
            width: "320px",
            className: styles.cell,
            render: (row) => (
                <div className={styles.truncate} title={row.content}>
                    {row.content}
                </div>
            ),
        },

        {
            key: "status",
            label: "Status",
            width: "140px",
            headerClassName: styles.tableHeader,
            className: styles.cell,
            render: () => (
                <span className={`${styles.status} ${styles.approved}`}>
                    APPROVED
                </span>
            ),
        },
        {
            key: "action",
            label: "Action",
            width: "120px",
            headerClassName: styles.tableHeader,
            className: styles.cell,
            render: (row) =>
                row.entity_id === "1001487500000015900" ||
                    row.entity_id === "1201160578232705664" ||
                    enableEdit === 0 ? (
                    <span className={`${styles.status} ${styles.pending}`}>
                        Default Template{" "}
                    </span>
                ) : (
                    <Link to={`/dashboard/sms-template/edit/${row.id}`}>
                        <span className={styles.editBtn}>
                            <FontAwesomeIcon icon={faEdit} />
                        </span>
                    </Link>
                ),
        },
    ];

    return (
        <TemplateDataTable
            columns={smsColumns}
            fetchData={fetchSmsTemplates}
            pageSize={5}
            flags={{ search: true, pagination: true }}
            searchPlaceholder="Search SMS templates"
        />
    );
};

export default SmsTemplate;
